import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CoBuyProductApi, UpdateCoBuyProductStatus } from 'api';

export const findCoBuyProduct = createAsyncThunk(
  'coBuyProduct/findCoBuyProduct',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await CoBuyProductApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiCoBuyProduct = createAsyncThunk(
  'coBuyProduct/createMultiCoBuyProduct',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await CoBuyProductApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCoBuyProduct = createAsyncThunk(
  'coBuyProduct/updateCoBuyProduct',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CoBuyProductApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCoBuyProductStatus = createAsyncThunk(
  'coBuyProduct/updateCoBuyProductStatus',
  async (
    params: { id: string; body: UpdateCoBuyProductStatus },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await CoBuyProductApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeCoBuyProduct = createAsyncThunk(
  'coBuyProduct/removeCoBuyProduct',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CoBuyProductApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createPromotion = createAsyncThunk(
  'coBuyProduct/createPromotion',
  async (
    params: { coBuyProductId: string; body: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await CoBuyProductApi.createPromotion(
        params.coBuyProductId,
        params.body
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updatePromotion = createAsyncThunk(
  'coBuyProduct/updatePromotion',
  async (
    params: { coBuyProductId: string; coBuyPromotionId: string; body: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await CoBuyProductApi.updatePromotion(
        params.coBuyProductId,
        params.coBuyPromotionId,
        params.body
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removePromotion = createAsyncThunk(
  'coBuyProduct/deletePromotion',
  async (
    params: { coBuyProductId: string; coBuyPromotionId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await CoBuyProductApi.deletePromotion(
        params.coBuyProductId,
        params.coBuyPromotionId
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
};

const coBuyProductSlice = createSlice({
  name: 'coBuyProduct',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findCoBuyProduct.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: coBuyProductReducer } = coBuyProductSlice;

export default coBuyProductReducer;
